import React from 'react';
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';

interface WateringNeedsSliderProps {
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  watch: UseFormWatch<any>;
  defaultValue?: number;
}

const WateringNeedsSlider: React.FC<WateringNeedsSliderProps> = ({
  register,
  setValue,
  watch,
  defaultValue = 5
}) => {
  const rawValue = watch('waterIntSet');
  const currentValue = rawValue === -1 ? defaultValue : (rawValue || defaultValue);

  return (
    <div className="block">
      <label
        htmlFor="waterIntSet"
        className="block text-left text-xs font-bold text-gray-700 uppercase tracking-wider mb-2"
      >
        Adjust watering needs
      </label>
      <div>
        <p className="block text-left text-sm text-gray-700 tracking-wider mb-2"
      >
If needed, adjust the watering below. Left = less water, right = more water.</p>
      </div>
      <div className="relative">
        <input
          type="range"
          id="waterIntSet"
          min="1"
          max="9"
          step="1"
          defaultValue={defaultValue}
          {...register('waterIntSet', {
            valueAsNumber: true
          })}
          className="w-full h-2 rounded-lg appearance-none cursor-pointer"
          style={{
            background: `linear-gradient(to right, #EF4444 0%, #3B82F6 60%)`,
          }}
        />
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>Less Water</span>
          <span className="text-center">Average</span>
          <span>More Water</span>
        </div>
        <div className="text-center text-xs text-gray-500 mt-1">
          Current: {currentValue}
        </div>
      </div>
      <style>{`
        input[type="range"]::-webkit-slider-thumb {
          appearance: none;
          width: 20px;
          height: 20px;
          background: white;
          border: 2px solid #3B82F6;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
        input[type="range"]::-moz-range-thumb {
          width: 20px;
          height: 20px;
          background: white;
          border: 2px solid #3B82F6;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default WateringNeedsSlider;